// Auto-generated from 941 Grama Panchayats.xlsx
// Structure: { District: { BlockPanchayat: [GramaPanchayat, ...] } }
export const GRAMA_PANCHAYATS_BY_DISTRICT_BLOCK = {
  "Alappuzha": {
    "Ambalappuzha": [
      "Ambalappuzha North",
      "Ambalappuzha South",
      "Punnapra North",
      "Punnapra South",
      "Purakkad"
    ],
    "Aryad": [
      "Aryad",
      "Mannancherry",
      "Mararikulam South",
      "Muhamma"
    ],
    "Bharanickavu": [
      "Bharanickavu",
      "Chunakara",
      "Mavelikara Thamarakulam",
      "Nooranad",
      "Palamel",
      "Vallikunnam"
    ],
    "Champakulam": [
      "Champakulam",
      "Edathua",
      "Kainakary",
      "Nedumudi",
      "Thakazhy",
      "Thalavady"
    ],
    "Chengannur": [
      "Ala",
      "Budhanoor",
      "Cheriyanad",
      "Mulakuzha",
      "Pandanad",
      "Puliyoor",
      "Thiruvanvandoor",
      "Venmoney"
    ],
    "Haripad": [
      "Cheruthana",
      "Karthikappally",
      "Karuvatta",
      "Kumarapuram",
      "Pallippad",
      "Thrikkunnappuzha",
      "Veeyapuram"
    ],
    "Kanjikuzhy": [
      "Cherthala South",
      "Kadakkarappally",
      "Kanjikuzhy",
      "Mararikulam North",
      "Thanneermukkom"
    ],
    "Mavelikara": [
      "Chennithala-Thripperumthura",
      "Chettikulangara",
      "Mannar",
      "Mavelikara Thekkekara",
      "Thazhakara"
    ],
    "Muthukulam": [
      "Arattupuzha",
      "Cheppad",
      "Chingoli",
      "Devikulangara",
      "Kandalloor",
      "Krishnapuram",
      "Muthukulam",
      "Pathiyoor"
    ],
    "Pattanakkad": [
      "Aroor",
      "Ezhupunna",
      "Kodamthuruth",
      "Kuthiathod",
      "Pattanakkad",
      "Thuravoor",
      "Vayalar"
    ],
    "Thycattussery": [
      "Arookutty",
      "Chennam Pallippuram",
      "Panavally",
      "Perumpalam",
      "Thycattussery"
    ],
    "Veliyanad": [
      "Kavalam",
      "Muttar",
      "Neelamperoor",
      "Pulincunnoo",
      "Ramankary",
      "Veliyanad"
    ]
  },
  "Ernakulam": {
    "Alangad": [
      "Alangad",
      "Kadungalloor",
      "Karumallur",
      "Varapuzha"
    ],
    "Angamaly": [
      "Ayyampuzha",
      "Kalady",
      "Kanjoor",
      "Karukutty",
      "Malayattoor Neeleeswaram",
      "Manjapra",
      "Mookkannur",
      "Thuravoor"
    ],
    "Edappally": [
      "Cheranalloor",
      "Elankunnapuzha",
      "Kadamakudy",
      "Mulavukad"
    ],
    "Koovappady": [
      "Asamannoor",
      "Koovappady",
      "Mudakuzha",
      "Okkal",
      "Rayamangalam",
      "Vengoor"
    ],
    "Kothamangalam": [
      "Kavalangad",
      "Keerampara",
      "Kottappady",
      "Kuttampuzha",
      "Nellikuzhi",
      "Paingottoor",
      "Pallarimangalam",
      "Pindimana",
      "Pothanicad",
      "Varappetty"
    ],
    "Mulanthuruthy": [
      "Amballoor",
      "Chottanikkara",
      "Edakkattuvayal",
      "Maneed",
      "Mulanthuruthy",
      "Udayamperoor"
    ],
    "Muvattupuzha": [
      "Arakuzha",
      "Avoly",
      "Ayavana",
      "Kalloorkad",
      "Manjalloor",
      "Marady",
      "Paipra",
      "Valakom"
    ],
    "Palluruthy": [
      "Chellanam",
      "Kumbalam",
      "Kumbalanghi"
    ],
    "Pampakuda": [
      "Elanji",
      "Palakuzha",
      "Pampakuda",
      "Ramamangalam",
      "Thirumarady"
    ],
    "Parakkadavu": [
      "Chengamanad",
      "Kunnukara",
      "Nedumbassery",
      "Parakkadavu",
      "Puthenvelikkara",
      "Sreemoolanagaram"
    ],
    "Paravur": [
      "Chendamangalam",
      "Chittattukara",
      "Ezhikkara",
      "Kottuvally",
      "Vadakkekkara"
    ],
    "Vadavucode": [
      "Aikaranad",
      "Kunnathunad",
      "Mazhuvannoor",
      "Poothrikka",
      "Thiruvaniyoor",
      "Vadavucode Puthencruz"
    ],
    "Vazhakulam": [
      "Choornikkara",
      "Edathala",
      "Keezhmad",
      "Kizhakkambalam",
      "Vazhakulam",
      "Vengola"
    ],
    "Vypin": [
      "Edavanakkad",
      "Kuzhuppilly",
      "Narakal",
      "Nayarambalam",
      "Pallippuram"
    ]
  },
  "Idukki": {
    "Adimaly": [
      "Adimaly",
      "Bisonvalley",
      "Konnathady",
      "Pallivasal",
      "Vellathooval"
    ],
    "Azhutha": [
      "Elappara",
      "Kokkayar",
      "Kumily",
      "Peermade",
      "Peruvanthanam",
      "Vandiperiyar"
    ],
    "Devikulam": [
      "Chinnakanal",
      "Devikulam",
      "Edamalakudi",
      "Kanthalloor",
      "Mankulam",
      "Marayoor",
      "Munnar",
      "Santhanpara",
      "Vattavada"
    ],
    "Elemdesam": [
      "Alakode",
      "Karimannoor",
      "Kodikulam",
      "Kudayathoor",
      "Udumbanoor",
      "Vannappuram",
      "Velliyamattom"
    ],
    "Idukki": [
      "Arakulam",
      "Idukki Kanjikuzhy",
      "Kamakshy",
      "Mariyapuram",
      "Vathikudy",
      "Vazhathope"
    ],
    "Kattappana": [
      "Ayyappan Coil",
      "Chakkupallam",
      "Erattayar",
      "Kanchiyar",
      "Upputhara",
      "Vandanmedu"
    ],
    "Nedumkandam": [
      "Karunapuram",
      "Nedumkandam",
      "Pampadumpara",
      "Rajakkad",
      "Rajakumary",
      "Senapathy",
      "Udumbanchola"
    ],
    "Thodupuzha": [
      "Edavetty",
      "Karimkunnam",
      "Kumaramangalam",
      "Manakkad",
      "Muttom",
      "Purapuzha"
    ]
  },
  "Kannur": {
    "Edakkad": [
      "Chembilode",
      "Kadambur",
      "Kolachery",
      "Munderi",
      "Peralassery"
    ],
    "Irikkur": [
      "Eruvessy",
      "Irikkur",
      "Kuttiattoor",
      "Malappattam",
      "Mayyil",
      "Padiyoor",
      "Payyavoor",
      "Ulikkal"
    ],
    "Iritty": [
      "Aralam",
      "Ayyankunnu",
      "Keezhallur",
      "Koodali",
      "Payam",
      "Thillankery"
    ],
    "Kalliasseri": [
      "Cherukunnu",
      "Cheruthazham",
      "Ezhome",
      "Kalliasseri",
      "Kannapuram",
      "Madayi",
      "Mattool",
      "Narath"
    ],
    "Kannur": [
      "Azhikode",
      "Chirakkal",
      "Pappinisseri",
      "Valapattanam"
    ],
    "Kuthuparamba": [
      "Chittariparamba",
      "Kottayam",
      "Kunnothuparamba",
      "Mangattidam",
      "Pattiam",
      "Triprangottoor"
    ],
    "Panoor": [
      "Chokli",
      "Kadirur",
      "Mokeri",
      "Panniyannur"
    ],
    "Payyannur": [
      "Cherupuzha",
      "Eramam Kuttur",
      "Kankol - Alappadamba",
      "Karivellur Peralam",
      "Kunhimangalam",
      "Peringome Vayakkara",
      "Ramanthali"
    ],
    "Peravoor": [
      "Kanichar",
      "Kelakam",
      "Kolayad",
      "Kottiyoor",
      "Malur",
      "Muzhakkunnu",
      "Peravoor"
    ],
    "Thalassery": [
      "Anjarakandy",
      "Dharmadam",
      "Eranholi",
      "Muzhappilangad",
      "New Mahe",
      "Pinarayi",
      "Vengad"
    ],
    "Thalipparamba": [
      "Alakode",
      "Chapparapadava",
      "Chengalayi",
      "Kadannappally Panapuzha",
      "Kurumathur",
      "Naduvil",
      "Pariyaram",
      "Pattuvam",
      "Udayagiri"
    ]
  },
  "Kasaragod": {
    "Kanhangad": [
      "Ajanur",
      "Madikai",
      "Pallikere",
      "Pullur Periya",
      "Udma"
    ],
    "Karadka": [
      "Bedadka",
      "Bellur",
      "Delampady",
      "Karadka",
      "Kumbadaje",
      "Kuttikol",
      "Muliyar"
    ],
    "Kasaragod": [
      "Badiadka",
      "Chemnad",
      "Chengala",
      "Kumbla",
      "Madhur",
      "Mogral Puthur"
    ],
    "Manjesaram": [
      "Enmakaje",
      "Mangalpady",
      "Manjeshwar",
      "Meenja",
      "Paivalike",
      "Puthige",
      "Vorkady"
    ],
    "Nileswaram": [
      "Cheruvathur",
      "Kayyur Cheemeni",
      "Padne",
      "Pilicode",
      "Trikarpur",
      "Valiyaparamba"
    ],
    "Parappa": [
      "Balal",
      "East Eleri",
      "Kallar",
      "Kinanoor - Karinthalam",
      "Kodom Belur",
      "Panathady",
      "West Eleri"
    ]
  },
  "Kollam": {
    "Anchal": [
      "Alayamon",
      "Anchal",
      "Aryankavu",
      "Edamulackal",
      "Karavaloor",
      "Kulathupuzha",
      "Thenmala",
      "Yeroor"
    ],
    "Chadayamangalam": [
      "Chadayamangalam",
      "Chithara",
      "Elamadu",
      "Ittiva",
      "Kadakkal",
      "Kummil",
      "Nilamel",
      "Velinalloor"
    ],
    "Chavara": [
      "Chavara",
      "Neendakara",
      "Panmana",
      "Thekkumbhagom",
      "Thevalakkara"
    ],
    "Chittumala": [
      "East Kallada",
      "Kundara",
      "Munroethuruth",
      "Panayam",
      "Perayam",
      "Perinad",
      "Thrikkaruva"
    ],
    "Ithikkara": [
      "Adichanalloor",
      "Chathannoor",
      "Chirakkara",
      "Kalluvathukkal",
      "Poothakulam"
    ],
    "Kottarakara": [
      "Ezhukone",
      "Kareepra",
      "Neduvathoor",
      "Pooyappally",
      "Veliyam"
    ],
    "Mukhathala": [
      "Elampalloor",
      "Kottamkara",
      "Mayyanad",
      "Nedumpana",
      "Thrikkovilvattom"
    ],
    "Oachira": [
      "Alappad",
      "Clappana",
      "Kulasekharapuram",
      "Oachira",
      "Thazhava",
      "Thodiyoor"
    ],
    "Pathanapuram": [
      "Pathanapuram",
      "Pattazhi",
      "Pattazhi Vadakkekara",
      "Piravanthoor",
      "Thalavoor",
      "Vilakkudy"
    ],
    "Sasthamcotta": [
      "Kunnathoor",
      "Mynagappally",
      "Poruvazhy",
      "Sasthamcotta",
      "Sooranad North",
      "Sooranad South",
      "West Kallada"
    ],
    "Vettikavala": [
      "Kulakkada",
      "Melila",
      "Mylom",
      "Pavithreswaram",
      "Ummannoor",
      "Vettikavala"
    ]
  },
  "Kottayam": {
    "Erattupetta": [
      "Melukavu",
      "Moonnilavu",
      "Poonjar",
      "Poonjar Thekkekara",
      "Teekoy",
      "Thalanad",
      "Thalappalam",
      "Thidanad"
    ],
    "Ettumanoor": [
      "Arpookara",
      "Athirampuzha",
      "Aymanam",
      "Kumarakam",
      "Neendoor",
      "Thiruvarppu"
    ],
    "Kaduthuruthy": [
      "Kaduthuruthy",
      "Kallara",
      "Mulakulam",
      "Neezhoor",
      "Thalayolaparambu",
      "Velloor"
    ],
    "Kanjirappally": [
      "Erumeli",
      "Kanjirappally",
      "Koottickal",
      "Koruthodu",
      "Manimala",
      "Mundakayam",
      "Parathodu"
    ],
    "Lalam": [
      "Bharananganam",
      "Kadanad",
      "Karoor",
      "Kozhuvanal",
      "Meenachil",
      "Mutholy"
    ],
    "Madappally": [
      "Madappally",
      "Paippad",
      "Thrickodithanam",
      "Vakathanam",
      "Vazhappally"
    ],
    "Pallom": [
      "Ayarkunnam",
      "Kurichy",
      "Panachikkad",
      "Puthuppally",
      "Vijayapuram"
    ],
    "Pampady": [
      "Akalakunnam",
      "Elikulam",
      "Kidangoor",
      "Kooroppada",
      "Manarcad",
      "Meenadom",
      "Pallikkathode",
      "Pampady"
    ],
    "Uzhavoor": [
      "Kadaplamattom",
      "Kanakkary",
      "Kuravilangad",
      "Manjoor",
      "Marangattupilly",
      "Ramapuram",
      "Uzhavoor",
      "Veliyannoor"
    ],
    "Vaikom": [
      "Chempu",
      "Maravanthuruthu",
      "TV Puram",
      "Thalayazham",
      "Udayanapuram",
      "Vechoor"
    ],
    "Vazhoor": [
      "Chirakkadavu",
      "Kangazha",
      "Karukachal",
      "Nedumkunnam",
      "Vazhoor",
      "Vellavoor"
    ]
  },
  "Kozhikode": {
    "Balussery": [
      "Balussery",
      "Koorachundu",
      "Kottur",
      "Naduvannur",
      "Panangad",
      "Ulliyeri",
      "Unnikulum"
    ],
    "Chelannur": [
      "Chelannur",
      "Kakkodi",
      "Kakkur",
      "Nanminda",
      "Narikunni",
      "Thalakulathur"
    ],
    "Koduvally": [
      "Kattippara",
      "Kizhakkoth",
      "Kodanchery",
      "Koodaranhi",
      "Madavoor",
      "Omassery",
      "Puduppady",
      "Thamarassery",
      "Thiruvambadi"
    ],
    "Kozhikkode": [
      "Kadalundi",
      "Olavanna"
    ],
    "Kunnamangalam": [
      "Chathamangalam",
      "Karassery",
      "Kodiyathur",
      "Kunnamangalam",
      "Kuruvattoor",
      "Mavoor",
      "Perumanna",
      "Peruvayal"
    ],
    "Kunnummal": [
      "Kavilumpara",
      "Kayakkody",
      "Kunnummal",
      "Kuttiadi",
      "Maruthonkara",
      "Narippatta",
      "Velom"
    ],
    "Melady": [
      "Keezhariyur",
      "Meppayur",
      "Thikkodi",
      "Thurayur"
    ],
    "Panthalayani": [
      "Arikkulam",
      "Atholi",
      "Chemanchery",
      "Chengottukavu",
      "Moodadi"
    ],
    "Perambra": [
      "Chakkittapara",
      "Changaroth",
      "Cheruvannur",
      "Kayanna",
      "Koothali",
      "Nochad",
      "Perambra"
    ],
    "Thodannur": [
      "Ayancheri",
      "Maniyur",
      "Thiruvallur",
      "Villiappally"
    ],
    "Tuneri": [
      "Chekkiad",
      "Edacheri",
      "Nadapuram",
      "Purameri",
      "Tuneri",
      "Valayam",
      "Vanimal"
    ],
    "Vatakara": [
      "Azhiyur",
      "Chorode",
      "Eramala",
      "Onchiyam"
    ]
  },
  "Malappuram": {
    "Areacode": [
      "Areacode",
      "Cheacode",
      "Edavanna",
      "Kavanur",
      "Keezhuparamba",
      "Kuzhimanna",
      "Pulpatta",
      "Urangattiri"
    ],
    "Kalikavu": [
      "Amarambalam",
      "Chokkad",
      "Edappatta",
      "Kalikavu",
      "Karulai",
      "Karuvarakundu",
      "Tuvvur"
    ],
    "Kondotty": [
      "Chelembra",
      "Cherukavu",
      "Muthuvalloor",
      "Pallikkal",
      "Pulikkal",
      "Vazhakkad",
      "Vazhayur"
    ],
    "Kuttippuram": [
      "Athavanad",
      "Edayur",
      "Irimbiliyam",
      "Kalpakanchery",
      "Kuttipuram",
      "Marakkara"
    ],
    "Malappuram": [
      "Anakkayam",
      "Kodur",
      "Morayur",
      "Othukkungal",
      "Ponmala",
      "Pookkottur"
    ],
    "Mankada": [
      "Koottilangadi",
      "Kuruva",
      "Makkaraparamba",
      "Mankada",
      "Moorkkanad",
      "Puzhakkattiri"
    ],
    "Nilambur": [
      "Chaliyar",
      "Chungathara",
      "Edakkara",
      "Moothedam",
      "Pothukallu",
      "Vazhikkadavu"
    ],
    "Perinthalmanna": [
      "Aliparamba",
      "Angadippuram",
      "Elamkulam",
      "Keezhattur",
      "Melattur",
      "Pulamanthole",
      "Thazhekkode",
      "Vettathur"
    ],
    "Perumpadappa": [
      "Alamkode",
      "Maranchery",
      "Nannammukku",
      "Perumpadappa",
      "Veliancode"
    ],
    "Ponnani": [
      "Edapal",
      "Kaladi",
      "Tavanur",
      "Vattamkulam"
    ],
    "Tanur": [
      "Cheriyamundam",
      "Niramaruthur",
      "Ozhur",
      "Perumanna Klari",
      "Ponmundam",
      "Tanalur",
      "Valavannur"
    ],
    "Tirur": [
      "Mangalam",
      "Purathur",
      "Thalakkad",
      "Thirunavaya",
      "Triprangode",
      "Vettom"
    ],
    "Tirurangadi": [
      "Moonniyur",
      "Nannambra",
      "Peruvalloor",
      "Thenhipalam",
      "Vallikkunnu"
    ],
    "Vengara": [
      "Abdurahiman Nagar",
      "Edarikode",
      "Kannamangalam",
      "Oorakam",
      "Parappur",
      "Thennala",
      "Vengara"
    ],
    "Wandoor": [
      "Mampad",
      "Pandikkad",
      "Porur",
      "Thiruvali",
      "Thrikkalangodu",
      "Wandoor"
    ]
  },
  "Palakkad": {
    "Alathur": [
      "Alathur",
      "Erimayur",
      "Kannambra",
      "Kavassery",
      "Kizhakkencherry",
      "Puducode",
      "Tarur",
      "Vadakkenchery"
    ],
    "Attappady": [
      "Agali",
      "Pudur",
      "Sholayoor"
    ],
    "Chittur": [
      "Elappully",
      "Eruthenpathy",
      "Kozhinjampara",
      "Nallepilly",
      "Perumatty",
      "Polpully",
      "Vadakarapathy"
    ],
    "Kollengode": [
      "Koduvayur",
      "Kollengode",
      "Muthalamada",
      "Pattanchery",
      "Peruvemba",
      "Pudunagaram",
      "Vadavannur"
    ],
    "Kuzhalmannam": [
      "Kannadi",
      "Kottayi",
      "Kuthanur",
      "Kuzhalmannam",
      "Mathur",
      "Peringottukurissi",
      "Thenkurissi"
    ],
    "Malampuzha": [
      "Akathethara",
      "Kodumbu",
      "Malampuzha",
      "Marutharode",
      "Puduppariyaram",
      "Pudusseri"
    ],
    "Mannarkad": [
      "Alanallur",
      "Kanhirapuzha",
      "Karimba",
      "Kottopadam",
      "Kumaramputhur",
      "Tachampara",
      "Thachanattukara",
      "Thenkara"
    ],
    "Nemmara": [
      "Ayalur",
      "Elavancherry",
      "Melarcode",
      "Nelliyampathy",
      "Nemmara",
      "Pallassana",
      "Vandazhy"
    ],
    "Ottapalam": [
      "Ambalappara",
      "Ananganadi",
      "Chalavara",
      "Lakkidi - Perur",
      "Nellaya",
      "Trikkaderi",
      "Vallapuzha",
      "Vaniamkulam"
    ],
    "Palakkad": [
      "Keralassery",
      "Kongad",
      "Mankara",
      "Mannur",
      "Mundur",
      "Parali",
      "Pirayiri"
    ],
    "Pattambi": [
      "Koppam",
      "Kulukkallur",
      "Muthuthala",
      "Ongallur",
      "Paruthur",
      "Thiruvegappura",
      "Vilayur"
    ],
    "Sreekrishnapuram": [
      "Kadampazhipuram",
      "Karakurussi",
      "Karimpuzha",
      "Pookkottukavu",
      "Sreekrishnapuram",
      "Vellinezhi"
    ],
    "Trithala": [
      "Anakkara",
      "Chalissery",
      "Kappur",
      "Nagalassery",
      "Pattithara",
      "Thirumittacode",
      "Trithala"
    ]
  },
  "Pathanamthitta": {
    "Elanthoor": [
      "Chenneerkara",
      "Cherukole",
      "Elanthoor",
      "Kozhencherry",
      "Mallappuzhassery",
      "Naranganam",
      "Omalloor"
    ],
    "Koipuram": [
      "Ayroor",
      "Eraviperoor",
      "Ezhumattoor",
      "Koipuram",
      "Puramattom",
      "Thottappuzhassery"
    ],
    "Konni": [
      "Aruvappulam",
      "Konni",
      "Malayalapuzha",
      "Mylapra",
      "Pramadom",
      "Thannithodu",
      "Vallicode"
    ],
    "Mallappally": [
      "Anicadu",
      "Kallooppara",
      "Kaviyoor",
      "Kottanad",
      "Kottangal",
      "Kunnamthanam",
      "Mallappally"
    ],
    "Pandalam": [
      "Aranmula",
      "Kulanada",
      "Mezhuveli",
      "Pandalam Thekkekara",
      "Thumpamon"
    ],
    "Parakkode": [
      "Enadimangalam",
      "Erathu",
      "Ezhamkulam",
      "Kadampanad",
      "Kalanjoor",
      "Kodumon",
      "Pallickal"
    ],
    "Pulikeezhu": [
      "Kadapra",
      "Kuttoor",
      "Nedumpuram",
      "Niranam",
      "Peringara"
    ],
    "Ranni": [
      "Chittar",
      "Naranammoozhy",
      "Ranni",
      "Ranni Angadi",
      "Ranni Pazhavangadi",
      "Ranni Perunadu",
      "Seethathodu",
      "Vadaserikara",
      "Vechoochira"
    ]
  },
  "Thiruvananthapuram": {
    "Athiyannoor": [
      "Athiyannoor",
      "Kanjiramkulam",
      "Karumkulam",
      "Kottukal",
      "Venganoor"
    ],
    "Chirayinkeezhu": [
      "Anchuthengu",
      "Chirayinkeezhu",
      "Kadakkavoor",
      "Kizhuvilam",
      "Mudakkal",
      "Vakkom"
    ],
    "Kilimanoor": [
      "Karavaram",
      "Kilimanoor",
      "Madavoor",
      "Nagaroor",
      "Navaikulam",
      "Pallickal",
      "Pazhayakunnumel",
      "Pulimath"
    ],
    "Nedumangad": [
      "Anad",
      "Aruvikkara",
      "Karakulam",
      "Panavoor",
      "Vembayam"
    ],
    "Nemom": [
      "Balaramapuram",
      "Kalliyoor",
      "Malayinkeezh",
      "Maranalloor",
      "Pallichal",
      "Vilappil",
      "Vilavoorkal"
    ],
    "Parassala": [
      "Chenkal",
      "Karode",
      "Kulathoor",
      "Parassala",
      "Poovar",
      "Thirupuram"
    ],
    "Perumkadavila": [
      "Amboori",
      "Aryancode",
      "Kallikkadu",
      "Kollayil",
      "Kunnathukal",
      "Ottasekharamangalam",
      "Perumkadavila",
      "Vellarada"
    ],
    "Pothencode": [
      "Andoorkonam",
      "Azhoor",
      "Kadinamkulam",
      "Mangalapuram",
      "Pothencode"
    ],
    "Vamanapuram": [
      "Kallara",
      "Manickal",
      "Nanniyode",
      "Nellanad",
      "Pangode",
      "Peringammala",
      "Pullampara",
      "Vamanapuram"
    ],
    "Varkala": [
      "Chemmaruthy",
      "Cherunniyoor",
      "Edava",
      "Elakamon",
      "Manamboor",
      "Ottoor",
      "Vettoor"
    ],
    "Vellanad": [
      "Aryanad",
      "Kattakada",
      "Kuttichal",
      "Poovachal",
      "Tholicode",
      "Uzhamalakkal",
      "Vellanad",
      "Vithura"
    ]
  },
  "Thrissur": {
    "Anthikad": [
      "Anthikad",
      "Arimpur",
      "Chazhur",
      "Manalur",
      "Thanniyam"
    ],
    "Chalakudy": [
      "Athirappilly",
      "Kadukutty",
      "Kodassery",
      "Koratty",
      "Meloor",
      "Pariyaram"
    ],
    "Chavakkad": [
      "Kadappuram",
      "Orumanayur",
      "Punnayur",
      "Punnayurkulam",
      "Vadakkekkad"
    ],
    "Cherpu": [
      "Avinissery",
      "Cherpu",
      "Paralam",
      "Vallachira"
    ],
    "Chowannur": [
      "Choondal",
      "Chowannur",
      "Kadangode",
      "Kadavallur",
      "Kandanassery",
      "Kattakampal",
      "Porkulam",
      "Velur"
    ],
    "Irinjalakuda": [
      "Karalam",
      "Kattoor",
      "Muriyad",
      "Parappukkara"
    ],
    "Kodakara": [
      "Alagappanagar",
      "Kodakara",
      "Mattathur",
      "Nenmanikkara",
      "Pudukad",
      "Thrikkur",
      "Varandarappilly"
    ],
    "Mala": [
      "Aloor",
      "Annamanada",
      "Kuzhur",
      "Mala",
      "Poyya"
    ],
    "Mathilakam": [
      "Edathiruthy",
      "Edavilangu",
      "Eriyad",
      "Kaipamangalam",
      "Mathilakam",
      "Perinjanam",
      "Sreenarayanapuram"
    ],
    "Mullassery": [
      "Elavally",
      "Mullassery",
      "Pavaratty",
      "Venkitangu"
    ],
    "Ollukkara": [
      "Madakkathara",
      "Nadathara",
      "Pananchery",
      "Puthur"
    ],
    "Pazhayannur": [
      "Chelakkara",
      "Kondazhy",
      "Panjal",
      "Pazhayannur",
      "Thiruvilwamala",
      "Vallathol Nagar"
    ],
    "Puzhakkal": [
      "Adat",
      "Avanur",
      "Kaiparambu",
      "Kolazhy",
      "Mulakunnathukavu",
      "Tholur"
    ],
    "Thalikulam": [
      "Engandiyur",
      "Nattika",
      "Thalikulam",
      "Valapad",
      "Vatanappally"
    ],
    "Vellangallur": [
      "Padiyur",
      "Poomangalam",
      "Puthenchira",
      "Vellangallur",
      "Velukara"
    ],
    "Wadakanchery": [
      "Desamangalam",
      "Erumapetty",
      "Mullurkara",
      "Thekkumkara",
      "Varavoor"
    ]
  },
  "Wayanad": {
    "Kalpetta": [
      "Kottathara",
      "Meppadi",
      "Muppainad",
      "Muttil",
      "Padinharathara",
      "Pozhuthana",
      "Thariode",
      "Vengappally",
      "Vythiri"
    ],
    "Mananthavady": [
      "Edavaka",
      "Thavinhal",
      "Thirunelly",
      "Thondernad",
      "Vellamunda"
    ],
    "Panamaram": [
      "Kaniyambetta",
      "Mullankolly",
      "Panamaram",
      "Poothadi",
      "Pulpally"
    ],
    "Sulthan Bathery": [
      "Ambalavayal",
      "Meenangadi",
      "Nenmeni",
      "Noolpuzha"
    ]
  }
};

export const BLOCK_PANCHAYATS_BY_DISTRICT = {
  "Alappuzha": [
    "Ambalappuzha",
    "Aryad",
    "Bharanickavu",
    "Champakulam",
    "Chengannur",
    "Haripad",
    "Kanjikuzhy",
    "Mavelikara",
    "Muthukulam",
    "Pattanakkad",
    "Thycattussery",
    "Veliyanad"
  ],
  "Ernakulam": [
    "Alangad",
    "Angamaly",
    "Edappally",
    "Koovappady",
    "Kothamangalam",
    "Mulanthuruthy",
    "Muvattupuzha",
    "Palluruthy",
    "Pampakuda",
    "Parakkadavu",
    "Paravur",
    "Vadavucode",
    "Vazhakulam",
    "Vypin"
  ],
  "Idukki": [
    "Adimaly",
    "Azhutha",
    "Devikulam",
    "Elemdesam",
    "Idukki",
    "Kattappana",
    "Nedumkandam",
    "Thodupuzha"
  ],
  "Kannur": [
    "Edakkad",
    "Irikkur",
    "Iritty",
    "Kalliasseri",
    "Kannur",
    "Kuthuparamba",
    "Panoor",
    "Payyannur",
    "Peravoor",
    "Thalassery",
    "Thalipparamba"
  ],
  "Kasaragod": [
    "Kanhangad",
    "Karadka",
    "Kasaragod",
    "Manjesaram",
    "Nileswaram",
    "Parappa"
  ],
  "Kollam": [
    "Anchal",
    "Chadayamangalam",
    "Chavara",
    "Chittumala",
    "Ithikkara",
    "Kottarakara",
    "Mukhathala",
    "Oachira",
    "Pathanapuram",
    "Sasthamcotta",
    "Vettikavala"
  ],
  "Kottayam": [
    "Erattupetta",
    "Ettumanoor",
    "Kaduthuruthy",
    "Kanjirappally",
    "Lalam",
    "Madappally",
    "Pallom",
    "Pampady",
    "Uzhavoor",
    "Vaikom",
    "Vazhoor"
  ],
  "Kozhikode": [
    "Balussery",
    "Chelannur",
    "Koduvally",
    "Kozhikkode",
    "Kunnamangalam",
    "Kunnummal",
    "Melady",
    "Panthalayani",
    "Perambra",
    "Thodannur",
    "Tuneri",
    "Vatakara"
  ],
  "Malappuram": [
    "Areacode",
    "Kalikavu",
    "Kondotty",
    "Kuttippuram",
    "Malappuram",
    "Mankada",
    "Nilambur",
    "Perinthalmanna",
    "Perumpadappa",
    "Ponnani",
    "Tanur",
    "Tirur",
    "Tirurangadi",
    "Vengara",
    "Wandoor"
  ],
  "Palakkad": [
    "Alathur",
    "Attappady",
    "Chittur",
    "Kollengode",
    "Kuzhalmannam",
    "Malampuzha",
    "Mannarkad",
    "Nemmara",
    "Ottapalam",
    "Palakkad",
    "Pattambi",
    "Sreekrishnapuram",
    "Trithala"
  ],
  "Pathanamthitta": [
    "Elanthoor",
    "Koipuram",
    "Konni",
    "Mallappally",
    "Pandalam",
    "Parakkode",
    "Pulikeezhu",
    "Ranni"
  ],
  "Thiruvananthapuram": [
    "Athiyannoor",
    "Chirayinkeezhu",
    "Kilimanoor",
    "Nedumangad",
    "Nemom",
    "Parassala",
    "Perumkadavila",
    "Pothencode",
    "Vamanapuram",
    "Varkala",
    "Vellanad"
  ],
  "Thrissur": [
    "Anthikad",
    "Chalakudy",
    "Chavakkad",
    "Cherpu",
    "Chowannur",
    "Irinjalakuda",
    "Kodakara",
    "Mala",
    "Mathilakam",
    "Mullassery",
    "Ollukkara",
    "Pazhayannur",
    "Puzhakkal",
    "Thalikulam",
    "Vellangallur",
    "Wadakanchery"
  ],
  "Wayanad": [
    "Kalpetta",
    "Mananthavady",
    "Panamaram",
    "Sulthan Bathery"
  ]
};

export const MUNICIPALITIES_BY_DISTRICT = {
  "Alappuzha": [
    "Alappuzha",
    "Chengannur",
    "Cherthala",
    "Haripad",
    "Kayamkulam",
    "Mavelikkara"
  ],
  "Ernakulam": [
    "Aluva",
    "Angamaly",
    "Eloor",
    "Kalamassery",
    "Koothattukulam",
    "Kothamangalam",
    "Maradu",
    "Muvattupuzha",
    "Paravur",
    "Perumbavoor",
    "Piravom",
    "Thrikkakara",
    "Thrippunithura"
  ],
  "Idukki": [
    "Thodupuzha"
  ],
  "Kannur": [
    "Anthoor",
    "Iritty",
    "Koothuparamba",
    "Mattannur",
    "Panoor",
    "Payyannur",
    "Sreekandapuram",
    "Taliparamba",
    "Thalassery"
  ],
  "Kasaragod": [
    "Kanhangad",
    "Kasaragod",
    "Nileshwar"
  ],
  "Kollam": [
    "Karunagappally",
    "Kottarakara",
    "Paravoor",
    "Punalur"
  ],
  "Kottayam": [
    "Changanassery",
    "Erattupetta",
    "Ettumanoor",
    "Kottayam",
    "Palai",
    "Vaikom"
  ],
  "Kozhikode": [
    "Feroke",
    "Koduvally",
    "Koyilandy",
    "Mukkam",
    "Payyoli",
    "Ramanattukara",
    "Vatakara"
  ],
  "Malappuram": [
    "Kondotty",
    "Kottakkal",
    "Malappuram",
    "Manjeri",
    "Nilambur",
    "Parappanangadi",
    "Perinthalmanna",
    "Ponnani",
    "Tanur",
    "Tirur",
    "Tirurangadi",
    "Valanchery"
  ],
  "Palakkad": [
    "Cherpulassery",
    "Chittur- Thathamangalam",
    "Mannarkad",
    "Ottappalam",
    "Palakkad",
    "Pattambi",
    "Shoranur"
  ],
  "Pathanamthitta": [
    "Adoor",
    "Pandalam",
    "Pathanamthitta",
    "Thiruvalla"
  ],
  "Thiruvananthapuram": [
    "Attingal",
    "Nedumangad",
    "Neyyattinkara",
    "Varkala"
  ],
  "Thrissur": [
    "Chalakudy",
    "Chavakkad",
    "Guruvayoor",
    "Irinjalakuda",
    "Kodungallur",
    "Kunnamkulam",
    "Wadakanchery"
  ],
  "Wayanad": [
    "Kalpetta",
    "Kattappana",
    "Mananthavady",
    "Sulthan Bathery"
  ]
};

export const CORPORATIONS_BY_DISTRICT = {
  "Ernakulam": [
    "Kochi"
  ],
  "Kannur": [
    "Kannur"
  ],
  "Kollam": [
    "Kollam"
  ],
  "Kozhikode": [
    "Kozhikode"
  ],
  "Thiruvananthapuram": [
    "Thiruvananthapuram"
  ],
  "Thrissur": [
    "Thrissur"
  ]
};

export const DISTRICT_PANCHAYATS_BY_DISTRICT = {
  "Alappuzha": [
    "Alappuzha"
  ],
  "Ernakulam": [
    "Ernakulam"
  ],
  "Idukki": [
    "Idukki"
  ],
  "Kannur": [
    "Kannur"
  ],
  "Kasaragod": [
    "Kasaragod"
  ],
  "Kollam": [
    "Kollam"
  ],
  "Kottayam": [
    "Kottayam"
  ],
  "Kozhikode": [
    "Kozhikode"
  ],
  "Malappuram": [
    "Malappuram"
  ],
  "Palakkad": [
    "Palakkad"
  ],
  "Pathanamthitta": [
    "Pathanamthitta"
  ],
  "Thiruvananthapuram": [
    "Thiruvananthapuram"
  ],
  "Thrissur": [
    "Thrissur"
  ],
  "Wayanad": [
    "Wayanad"
  ]
};
